module.exports = __webpack_public_path__ + "img/Gelangweilt.891c1806.svg";